/* import __COLOCATED_TEMPLATE__ from './typeahead.hbs.js'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import trustedStyle from '@intercom/pulse/lib/trusted-style';
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import { ref } from 'ember-ref-bucket';
let Typeahead = (_dec = ref('List'), (_class = class Typeahead extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "isVisible", _descriptor, this);
    _initializerDefineProperty(this, "matchResult", _descriptor2, this);
    _initializerDefineProperty(this, "selectedIndex", _descriptor3, this);
    _initializerDefineProperty(this, "scrollLeft", _descriptor4, this);
    _initializerDefineProperty(this, "scrollTop", _descriptor5, this);
    _initializerDefineProperty(this, "list", _descriptor6, this);
    //eslint-disable-line
    _defineProperty(this, "listPadding", 10);
    _defineProperty(this, "itemPadding", 4);
    this.isVisible = true;
    this.setInitialSelectedIndex();
    this.scrollTop = 0;
    this.scrollLeft = 0;
  }
  get height() {
    return Math.min(this.items.length * this.itemHeight + this.listPadding * 2, 300);
  }
  get sizeStyle() {
    return trustedStyle`height: ${this.height}px; width: ${this.itemWidth}px`;
  }
  get itemWidth() {
    return this.args.itemWidth || 245;
  }
  get itemHeight() {
    return this.args.itemHeight || 32;
  }
  get itemSizeStyle() {
    return trustedStyle`height: ${this.itemHeight - this.itemPadding * 2}px`;
  }
  get items() {
    return this.args.items;
  }
  get lastObj() {
    return this.items[this.items.length - 1];
  }
  get disabledItems() {
    return this.args.disabledItems;
  }
  get popoverClass() {
    return this.args.popoverClass;
  }
  setInitialSelectedIndex() {
    if (!this.disabledItems || this.disabledItems.length === 0) {
      this.selectedIndex = 0;
    } else {
      this.selectedIndex = this.items.findIndex(item => !this.itemIsDisabled(item));
    }
  }
  itemIsDisabled(item) {
    return this.disabledItems?.includes(item);
  }
  handleKeyboardEvent(e) {
    switch (e.key) {
      case 'ArrowUp':
        this.selectPrevious();
        break;
      case 'ArrowDown':
        this.selectNext();
        break;
      case 'Enter':
      case 'Tab':
        if (this.selectedIndex !== undefined) {
          this.args.onSelect(this.items[this.selectedIndex]);
        }
        break;
      case 'Escape':
        this.closeTypeahead();
        break;
    }
  }
  selectPrevious() {
    if (this.selectedIndex !== undefined) {
      this.selectedIndex--;
      if (this.selectedIndex < 0) {
        this.selectedIndex = this.items.length - 1;
      }
      if (this.itemIsDisabled(this.items[this.selectedIndex])) {
        this.selectPrevious();
        return;
      }
      this.scrollToSelected();
    }
  }
  selectNext() {
    if (this.selectedIndex !== undefined) {
      this.selectedIndex++;
      if (this.selectedIndex >= this.items.length) {
        this.selectedIndex = 0;
      }
      if (this.itemIsDisabled(this.items[this.selectedIndex])) {
        this.selectNext();
        return;
      }
      this.scrollToSelected();
    }
  }
  scrollToSelected() {
    if (this.selectedIndex !== undefined) {
      let selectedItemScrollPosition = (this.selectedIndex + 1) * this.itemHeight - this.scrollTop;
      if (selectedItemScrollPosition - this.listPadding < this.itemHeight) {
        this.scrollTop = this.selectedIndex * this.itemHeight;
      } else if (selectedItemScrollPosition + this.itemHeight + this.listPadding > this.height) {
        this.scrollTop = this.selectedIndex * this.itemHeight - (this.height - this.itemHeight) + this.listPadding * 2;
      }
    }
  }
  closeTypeahead() {
    this.isVisible = false;
  }
  onInsert() {
    this.args.registerDelegate(this.keyboardEventDelegate);
    this.matchResult = this.args.matchResult;
  }
  onUpdate() {
    if (this.args.matchResult?.text !== this.matchResult?.text) {
      this.resetSelectedIndex();
      this.isVisible = true;
    }
    this.matchResult = this.args.matchResult;
  }
  onDestroy() {
    this.args.deregisterDelegate(this.keyboardEventDelegate);
  }
  keyboardEventDelegate(e) {
    //eslint-disable-next-line
    if (['ArrowUp', 'ArrowDown', 'Enter', 'Tab', 'Escape'].includes(e.key)) {
      this.handleKeyboardEvent(e);
      e.preventDefault();
    }
    return true;
  }
  onItemMouseEnter(index) {
    if (!this.itemAtIndexIsDisabled(index)) {
      this.selectedIndex = index;
    }
  }
  resetSelectedIndex() {
    this.setInitialSelectedIndex();
  }
  itemAtIndexIsDisabled(index) {
    return this.disabledItems?.includes(this.items[index]);
  }
  onItemClick(item) {
    if (!this.itemIsDisabled(item)) {
      this.args.onSelect(item);
    }
  }
  scrollChange(scrollLeft, scrollTop) {
    this.scrollLeft = scrollLeft;
    this.scrollTop = scrollTop;
  }
  onDocumentClick(e) {
    let element = e.target;
    do {
      if (element.classList.contains('embercom-prosemirror-composer-typeahead-item')) {
        return;
      }
    } while (element = element.parentElement);
    this.closeTypeahead();
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isVisible", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "matchResult", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "selectedIndex", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "scrollLeft", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "scrollTop", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "list", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onInsert", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInsert"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onUpdate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onUpdate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDestroy", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDestroy"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "keyboardEventDelegate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "keyboardEventDelegate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onItemMouseEnter", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onItemMouseEnter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetSelectedIndex", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resetSelectedIndex"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "itemAtIndexIsDisabled", [action], Object.getOwnPropertyDescriptor(_class.prototype, "itemAtIndexIsDisabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onItemClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onItemClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "scrollChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "scrollChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDocumentClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDocumentClick"), _class.prototype)), _class));
export { Typeahead as default };